import {
  aiPlannerSettingsListenerEpic,
  saveAIPlannerSettingsEpic,
} from '@bridebook/web/lib/ai-planner/epics/ai-planner-settings-epics';
import { persistAIPlannerPanelEpic } from '@bridebook/web/lib/ai-planner/epics/persist-ai-planner-panel-epic';
import { restoreAIPlannerPanelEpic } from '@bridebook/web/lib/ai-planner/epics/restore-ai-planner-panel-epic';
import { combineEpics } from 'redux-observable';

export const aiPlannerEpics = combineEpics(
  restoreAIPlannerPanelEpic,
  persistAIPlannerPanelEpic,
  aiPlannerSettingsListenerEpic,
  saveAIPlannerSettingsEpic,
);
